import React from "react";
import { useHistory } from "react-router-dom";
import { useGlobalValue } from "../utils/GlobalState";

export default function Home() {
  const [{ isLoggedIn }] = useGlobalValue();
  let history = useHistory();

  if (!isLoggedIn) {
    history.push("/login")
  }

  return <div>This is the home page</div>;
}
